// extracted by mini-css-extract-plugin
export var loadingShimmer = "_qz-2";
export var messageContent = "_qz-0";
export var messagesScroll = "_qz-1";
export var shimmer = "_qz-3";
export var shimmerW100 = "_qz-4";
export var shimmerW70 = "_qz-8";
export var shimmerW80 = "_qz-7";
export var shimmerW85 = "_qz-6";
export var shimmerW90 = "_qz-5";